module.exports = __webpack_public_path__ + "6410e403d9f2c5342e1e98ca6f05b723.svg";